module.exports = __webpack_public_path__ + "img/about-2.dff3eb8c.jpg";